import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import BlogSearchBar from "@/pages/blog/components/BlogSearchBar";
import { getTagsWithCount } from "@/pages/blog/blogData";

export default function BlogHero() {
  const popularTags = getTagsWithCount().slice(0, 6);

  return (
    <section className="relative overflow-hidden bg-foreground-950 text-background-50">
      <div className="absolute inset-0 nx-grid opacity-30"></div>
      <div className="nx-glow absolute -top-40 right-0 h-[460px] w-[460px] animate-pulseGlow"></div>
      <div className="nx-glow absolute bottom-0 -left-40 h-[360px] w-[360px] animate-pulseGlow"></div>

      <div className="relative mx-auto w-full max-w-7xl px-4 pt-28 pb-16 md:px-8 md:pt-36 md:pb-20">
        <Reveal>
          <nav aria-label="Trilha de navegação" className="flex flex-wrap items-center gap-2 text-xs text-background-400">
            <Link to="/" className="transition-colors hover:text-background-50">
              Início
            </Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <span className="text-background-200">Blog</span>
          </nav>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 items-start gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <Reveal delay={80}>
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/5 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-300">
                <i className="ri-article-line" aria-hidden="true"></i>
                Blog NXHOST · Central de Conhecimento
              </span>
            </Reveal>

            <Reveal delay={140}>
              <h1 className="mt-6 font-heading text-3xl font-bold leading-[1.15] tracking-tight sm:text-4xl lg:text-[3rem]">
                Conteúdo para criar, proteger, otimizar e fazer sua presença digital crescer
              </h1>
            </Reveal>

            <Reveal delay={200}>
              <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
                Aprenda sobre hospedagem de sites, criação de sites, domínios, servidores, SEO, bancos de
                dados, marketing digital, Google Ads e muito mais.
              </p>
            </Reveal>
          </div>

          <Reveal delay={260} className="w-full">
            <div className="rounded-2xl border border-background-50/10 bg-background-50/5 p-5 backdrop-blur-sm md:p-6">
              <p className="text-sm font-semibold text-background-50">O que você quer aprender?</p>
              <p className="mt-1 text-xs text-background-400">
                Conteúdos práticos para quem quer criar, hospedar, otimizar e divulgar um site ou negócio na internet.
              </p>
              <div className="mt-4">
                <BlogSearchBar variant="hero" />
              </div>
              <div className="mt-4 flex flex-wrap items-center gap-2">
                <span className="text-xs text-background-400">Populares:</span>
                {popularTags.map((entry) => (
                  <Link
                    key={entry.tag}
                    to={`/blog/busca?q=${encodeURIComponent(entry.tag)}`}
                    className="rounded-full border border-background-50/15 px-3 py-1 text-xs text-background-200 transition-colors hover:border-accent-300 hover:text-accent-300"
                  >
                    {entry.tag}
                  </Link>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}